/* eslint-disable */
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  // Fetch FAQs from API
  const fetchFaqs = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await axios.get(`${API_BASE}/UIfaq`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data.results || res.data || [];
      
      // Filter only active FAQs and sort in ascending order
      const activeFaqs = data
        .filter(faq => faq.isActive === true)
        .sort((a, b) => {
          // Sort by createdAt date in ascending order (oldest first)
          if (a.createdAt && b.createdAt) {
            return new Date(a.createdAt) - new Date(b.createdAt);
          }
          // If no createdAt, sort by ID or maintain order
          return (a.id || 0) - (b.id || 0);
        });
      
      setFaqs(activeFaqs);
      
    } catch (error) {
      console.error("❌ Error fetching FAQs:", error);
      setError("Failed to load FAQs. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Loading state
  if (loading) {
    return (
      <div className="bg-gray-800 text-white min-h-screen relative overflow-hidden">
        <div className="absolute inset-0 z-0" />
        <section className="py-20 px-10 relative z-10 max-w-5xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-12 text-white">
            Frequently Asked Questions
          </h2>
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500"></div>
            <span className="ml-4 text-lg">Loading FAQs...</span>
          </div>
        </section>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="bg-gray-800 text-white min-h-screen relative overflow-hidden">
        <div className="absolute inset-0 z-0" />
        <section className="py-20 px-10 relative z-10 max-w-5xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-12 text-white">
            Frequently Asked Questions
          </h2>
          <div className="text-center py-20">
            <div className="text-6xl mb-4">⚠️</div>
            <p className="text-xl text-red-400 mb-4">{error}</p>
            <button 
              onClick={fetchFaqs}
              className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 px-6 py-3 rounded-lg font-semibold transition-colors"
            >
              Try Again
            </button>
          </div>
        </section>
      </div>
    );
  }

  // Empty state
  if (faqs.length === 0) {
    return (
      <div className="bg-gray-800 text-white min-h-screen relative overflow-hidden">
        <div className="absolute inset-0 z-0" />
        <section className="py-20 px-10 relative z-10 max-w-5xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-12 text-white">
            Frequently Asked Questions
          </h2>
          <div className="text-center py-20">
            <div className="text-6xl mb-4">📋</div>
            <p className="text-xl text-gray-400">No FAQs available at the moment.</p>
            <p className="text-gray-500 mt-2">Check back later for updates.</p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="bg-gray-800 text-white min-h-screen relative overflow-hidden">
      <div className="absolute inset-0 z-0" />

      {/* FAQs Section */}
      <section className="py-20 px-10 relative z-10 max-w-5xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-12 text-white">
          Frequently Asked Questions
        </h2>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={faq.id || index} className="bg-gray-900 p-6 rounded-xl overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full text-left text-xl font-semibold flex justify-between items-center hover:text-yellow-400 transition-colors"
              >
                {faq.question}
                <span className="text-2xl text-yellow-500">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.4 }}
                  >
                    <div className="mt-4 text-gray-300 text-base space-y-4">
                      {faq.answer.split("\n\n").map((paragraph, idx) => (
                        <p key={idx} className="whitespace-pre-line leading-relaxed">
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default FAQs;